export default __webpack_public_path__ + "static/media/mastercard.3aac6d1f.svg";